import { Component, inject } from '@angular/core';
import { Group_Reports } from 'src/app/Interfaces/Interfaces-Global/Reports.interface';
import { UserDataService } from 'src/app/Services/Authentication/User/user-data.service';
import { GeneralRoleCDMS, typeSystemRoleCDMS } from 'src/app/types/General/RoleCDMS.type';
import { OnInit } from '@angular/core';
import { LibraryMasterService } from 'src/app/Services/Libraries/Library-Master/library-master.service';
import { firstValueFrom } from 'rxjs';
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';
import { typeRoleCDMS } from 'src/app/types/General/RoleCDMS.type';

@Component({
    selector: 'app-all-roles-gener-cdms',
    templateUrl: './all-roles-gener-cdms.component.html',
    styleUrls: ['./all-roles-gener-cdms.component.scss', '../../../Styles/GlobalStyles.css'],
    standalone: false
})
export class AllRolesGenerCDMSComponent {


  //+================== VARIABLE ROLES GENERAL ==================+\\
  public RolesGeneral: typeSystemRoleCDMS = GeneralRoleCDMS;

  //-========================= SERVICES =========================-\\

  public UserService = inject(UserDataService);
  private MasterLibraryService = inject(LibraryMasterService);

  constructor() { }

  async ngOnInit(): Promise<void> {
    await this.LoadDynamicRoleLibraries();
  }

  //+================== VARIABLES FOR OPTION CARDS REPORTS ==================+\\

  public AllRoles: Group_Reports[] = [
    {
      Title: 'Administrative Processes',
      NotRelated: [],
      Roles: [this.RolesGeneral.AdministratorFIN, this.RolesGeneral.SuperAdministrator],
      Library: [
        {
          Library: 'Processes',
          Description: 'puede consultar los roles de Processes.',
          RouteLink: '/Dashboard/FIN/SeeAllRolesGenFIN',
          Roles: [this.RolesGeneral.AdministratorFIN, this.RolesGeneral.SuperAdministrator]
        },
        {
          Library: 'HOE',
          Description: 'puede consultar los roles de HOE.',
          RouteLink: '/Dashboard/Lib/hoe/Roles',
          Roles: [this.RolesGeneral.AdministratorHOE, this.RolesGeneral.SuperAdministrator]
        },
      ]
    }
  ]

  private async LoadDynamicRoleLibraries(): Promise<void> {
    try {
      const res: Response_FIN = await firstValueFrom(this.MasterLibraryService.Get_Active_Libraries());
      if (!res.success || !this.AllRoles[0]) {
        return;
      }

      const staticSlugs = ['processes', 'fin', 'ccp', 'hoe'];
      const roleGroup = this.AllRoles[0];

      for (const lib of res.operation || []) {
        const slug = String(lib?.Slug || '').toLowerCase();
        const slugUpper = String(lib?.Slug || '').toUpperCase();
        const libName = String(lib?.Nombre || slugUpper);

        if (!slug || staticSlugs.includes(slug)) {
          continue;
        }

        const administratorRole = `Administrator${slugUpper}` as typeRoleCDMS;

        if (!roleGroup.Roles.includes(administratorRole)) {
          roleGroup.Roles.push(administratorRole);
        }

        if (!roleGroup.Roles.includes(this.RolesGeneral.SuperAdministrator)) {
          roleGroup.Roles.push(this.RolesGeneral.SuperAdministrator);
        }

        const existsCard = roleGroup.Library.some((item) => item.RouteLink === `/Dashboard/Lib/${slug}/Roles`);
        if (!existsCard) {
          roleGroup.Library.push({
            Library: libName,
            Description: `puede consultar los roles de ${libName}.`,
            RouteLink: `/Dashboard/Lib/${slug}/Roles`,
            Roles: [administratorRole, this.RolesGeneral.SuperAdministrator]
          });
        }
      }
    } catch (e) {
      console.error('Error loading dynamic role libraries', e);
    }
  }


  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //-================== FUNCTTION FOR GREETTING ==================-\\

  public GetGreeting(): string {

    let TextGTings: string = '';

    const Date_User = new Date();
    const Hour = Date_User.getHours();

    if (Hour >= 0 && Hour <= 5) {
      TextGTings = 'Buenas noches';
    } else if (Hour >= 6 && Hour <= 11) {
      TextGTings = 'Buenos días';
    } else if (Hour >= 12 && Hour <= 17) {
      TextGTings = 'Buenas tardes';
    } else if (Hour >= 18) {
      TextGTings = 'Buenas noches';
    }

    return TextGTings;
  }

  //-================ FUNCTION FOR NAME USER ================-\\
  public NameUser(): string {
    const Name_User: string = localStorage.getItem('Name_User') || "";
    return (Name_User.split(' ', 2)).join(' ');
  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\

}
